import { Component, Input, inject } from "@angular/core";
import { FormLinkableModule } from "@app/forms/enums/FormLinkableModule";
import { FormsLinkModel } from "@app/forms/models/other/FormsLinkModel";
import { FormsDataService } from "@app/forms/services/forms-data.service";
import { LinkModel } from "@models/generic/LinkModel";
import { AuditModel } from "@app/audit/shared/data-models/audit-model";
import { FormLinkableComponent } from "@app/forms/pages/form-linkable/form-linkable.component";

@Component({
    selector: "audit-linked-forms",
    templateUrl: "./audit-linked-forms.component.html",
    styleUrls: ["./audit-linked-forms.component.scss"],
    imports: [FormLinkableComponent],
})
export class AuditLinkedFormsComponent {
    private formsDataService = inject(FormsDataService);

    @Input() model: AuditModel;
    @Input() disabled: boolean;

    protected linkedModule: FormLinkableModule = FormLinkableModule.Audit;
    protected linkableForms: FormsLinkModel[] = [];
    protected unlinked: FormsLinkModel[] = [];
    protected linked: FormsLinkModel[] = [];
    protected isLoading: boolean = true;

    public load(): void {
        this.formsDataService
            .getLinkableForms(this.linkedModule)
            .then((linkedForms: FormsLinkModel[]): void => {
                this.linkableForms = linkedForms;

                this.loadForms();

                this.isLoading = false;
            });
    }

    public linkedItemsChanged(linked: LinkModel[]): void {
        this.model.formIds = linked.map((link: LinkModel): number => link.id);

        this.loadForms();
    }

    private loadForms(): void {
        const linkedItems = [];
        const unlinkedItems = [];
        if (this.model.formIds && this.model.formIds.length > 0) {
            for (const form of this.linkableForms) {
                if (this.model.formIds.includes(form.id)) {
                    linkedItems.push(form);
                } else {
                    unlinkedItems.push(form);
                }
            }
        } else {
            unlinkedItems.addRange(this.linkableForms);
        }

        this.linked = linkedItems;
        this.unlinked = unlinkedItems;
    }
}
